import { supabase } from '../lib/supabase';

export interface EmailAttachment {
  filename: string;
  data: string;
}

export interface SendEmailParams {
  to: string;
  subject: string;
  text?: string;
  html?: string;
  attachment?: EmailAttachment;
}

export const sendEmail = async (params: SendEmailParams) => {
  const { to, subject, text, html, attachment } = params;

  if (!to || !subject) {
    throw new Error('Email address and subject are required');
  }

  try {
    const { data, error } = await supabase.functions.invoke('send-email', {
      body: {
        to: to.trim(),
        subject,
        text,
        html,
        attachment,
      },
    });

    if (error) {
      console.error('Edge function error:', error);
      throw new Error(`Failed to send email: ${error.message}`);
    }

    if (data?.error) {
      console.error('Email sending error:', data.details);
      throw new Error(data.details || 'Failed to send email');
    }

    return {
      success: true,
      messageId: data.messageId,
      message: 'Email sent successfully',
    };
  } catch (error) {
    console.error('Mailgun error:', error);

    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';

    if (errorMessage.includes('authentication')) {
      throw new Error('Mailgun authentication failed. Please check your API key.');
    } else if (errorMessage.includes('domain')) {
      throw new Error('Invalid Mailgun domain. Please check your configuration.');
    } else if (errorMessage.includes('recipient')) {
      throw new Error('Invalid recipient email address.');
    }

    throw new Error(`Failed to send email: ${errorMessage}`);
  }
};
